export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-21.jpg'),
        title: 'Gaming field',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'Gaming field',
      description: `<p>As a core business occupying nearly half of the global outsourcing market share, we have built a professional team consisting of 2D/3D artists, animators, and UI/UX designers. Our team is proficient in adapting to mainstream engines such as Unity and Unreal Engine, and capable of undertaking art asset production across all styles and genres. With over 200 successfully delivered projects and products served accumulating over 100 million downloads worldwide, we have established a strong track record in the industry.</p>
      <p>In an era where the global gaming industry has surpassed $180 billion in scale and player demand for quality continues to rise, game outsourcing has evolved from a "cost optimization tool" to a "strategic collaborative partner." With years of deep expertise in game outsourcing, we adhere to the philosophy of "technology-driven, quality-focused, and flexible adaptation." We provide global game developers with end-to-end outsourcing solutions—spanning art design, program development, and testing operations—empowering clients to concentrate on core creativity, accelerate product deployment, and seize market opportunities. Whether meeting the lightweight needs of independent studios or the large-scale demands of AAA studios, we offer customized services to overcome development bottlenecks and achieve dual enhancement in efficiency and quality.</p>`
    },
    {
      title: 'OUR ADVANTAGE',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-21.jpg')+`)"></span>
      <span class="list">
      <i></i>Top-tier R&D team with leading core technologies.<br/>
      <i></i>Global distribution network covering mainstream markets.<br/>
      <i></i>Extensive IP portfolio spanning diverse game genres.<br/>
      <i></i>Sustained innovation capability keeping pace with industry trends.<br/>
      <i></i>No additional costs required.<br/>
      </span>`
    }
  ]
}
